import React from "react";
import {ActionIcon, Group} from "@mantine/core";
import {IconRefresh, IconTrash, IconX} from "@tabler/icons-react";
import {IProtocolRawFile} from "@/protocols/types/IProtocolRawFile.ts";
import {UnifiedFileEntry} from "../hooks/useUnifiedFiles";
import {retryBrowserUpload} from "@/protocols/persistence/uploadCoordinator";
import {useUploadStatusStore} from "@/protocols/persistence/useUploadStatusStore";

interface FileActionsCellProps {
    entry: UnifiedFileEntry;
    onDelete: (file: IProtocolRawFile) => void;
}

export const FileActionsCell: React.FC<FileActionsCellProps> = ({entry, onDelete}) => {
    // Failed browser uploads: Retry re-runs the upload with the retained
    // File; X dismisses the row (drops the retained File too).
    if (entry.kind === 'failed' && entry.browserTempId !== undefined) {
        const tempId = entry.browserTempId;
        return (
            <Group gap={4} justify="center">
                <ActionIcon
                    size="sm"
                    color="blue"
                    variant="subtle"
                    title="Retry upload"
                    data-testid={`retry-browser-upload-${tempId}`}
                    onClick={(e) => {
                        e.stopPropagation();
                        void retryBrowserUpload(tempId);
                    }}
                >
                    <IconRefresh size={14}/>
                </ActionIcon>
                <ActionIcon
                    size="sm"
                    color="gray"
                    variant="subtle"
                    title="Dismiss"
                    data-testid={`dismiss-browser-upload-${tempId}`}
                    onClick={(e) => {
                        e.stopPropagation();
                        useUploadStatusStore.getState().removeBrowserUpload(tempId);
                    }}
                >
                    <IconX size={14}/>
                </ActionIcon>
            </Group>
        );
    }
    if (entry.kind !== 'uploaded' || !entry.serverFile) {
        return <></>;
    }
    return (
        <ActionIcon
            size="sm"
            color="red"
            variant="subtle"
            onClick={(e) => {
                e.stopPropagation();
                onDelete(entry.serverFile!);
            }}
        >
            <IconTrash size={14}/>
        </ActionIcon>
    );
};